
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"33","height":"33","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.846 32.167c-.842 0-1.554-.292-2.138-.875-.583-.584-.875-1.296-.875-2.138V6.846c0-.842.292-1.554.875-2.138.584-.583 1.296-.875 2.138-.875h14.427l-2.5 2.5H3.846a.49.49 0 00-.352.16.49.49 0 00-.16.353v22.308a.49.49 0 00.16.352.49.49 0 00.352.16h22.308a.49.49 0 00.352-.16.49.49 0 00.16-.352V17.122l2.5-2.5v14.532c0 .842-.29 1.554-.874 2.138-.584.583-1.296.875-2.138.875H3.846zm6.988-11.507v-2.968c0-.401.078-.788.234-1.158.155-.371.37-.693.644-.967l14.22-14.22c.26-.26.544-.448.853-.567.31-.118.625-.177.946-.177.327 0 .64.059.942.177.301.12.576.302.824.55l2.093 2.087c.241.258.427.543.556.855.13.312.194.629.194.95 0 .32-.055.63-.165.932-.11.301-.295.581-.553.84l-14.27 14.269a3.17 3.17 0 01-.966.657c-.37.164-.757.247-1.158.247H12.34a1.46 1.46 0 01-1.075-.432 1.46 1.46 0 01-.431-1.075zm2.5-.993h2.076L25.798 9.279 24.76 8.24l-1.112-1.07-10.314 10.314v2.183z","fill":"#fff"}})])
          )
        }
      }
    